import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { connect, Provider } from 'react-redux'
import store from '../store'
import globals from '../globals'
import * as Sentry from '@sentry/react'
import { getCustomer } from '../redux/actions'
import Navigation from './Navigation'
import BottomDetails from './BottomDetails'
import PrivateRoute from './PrivateRoute'
import Footer from './Footer'
import Notices from '../modules/Notices'

import Home from '../pages/Home'
import MyServices from '../pages/MyServices'
import MyAccount from '../pages/MyAccount'
import PaymentAndInvoices from '../pages/PaymentAndInvoices'
import Messages from '../pages/Messages'
import OrderModem from '../pages/OrderModem'
import HomePhoneVoip from '../pages/HomePhoneVoip'
import UnlimitedCallPack from '../pages/UnlimitedCallPack'
import Faqs from '../pages/Faqs'
import CrossStorageHub from '../pages/CrossStorageHub'
import NotFound from '../pages/NotFound'
import SentryTestError from '../pages/SentryTestError'
import SubscribeToHomeSecure from '../pages/SubscribeToHomeSecure'
import Login from '../auth/Login'
import Logout from '../auth/Logout'
import ForgotPassword from '../auth/ForgotPassword'
import ResetPassword from '../auth/ResetPassword'
import ForgotUsername from '../auth/ForgotUsername'
import SwitchToNbn from '../auth/SwitchToNbn'
import BroadbandService from '../services/BroadbandService'
import MobileService from '../services/MobileService'
import MobileBroadbandService from '../services/MobileBroadbandService'
import VoipService from '../services/VoipService'
import PstnService from '../services/PstnService'
import HomeSecureService from '../services/HomeSecureService'
import WirelessService from '../services/WirelessService'
import Error from '../pages/Error'
import MigrateMobile from '../pages/MigrateMobile'
import ExetelAFriend from '../pages/ExetelAFriend'
import SpeedBoostService from '../services/SpeedBoostService'
import SimOnlyPlan from '../pages/SImOnlyPlan'
import Mfa from '../auth/Mfa'
import { StandalonePayments } from '../pages/StandalonePayments'

class App extends React.Component {
    constructor (listen) {
        super(listen)

        this.screenSm = 991
        this.state = {
		    isMobile: (window.innerWidth <= this.screenSm),
            deferredPrompt: {}
        }

        this.dontShowNav = ['/', '/login', '/logout', '/forgot-password', '/reset-password', '/forgot-username', '/switch-to-nbn', '/mfa']
    }

    componentDidMount () {
        globals.animatePageIn(this.container)
        globals.setSentryUser()
        globals.setHotjarUser()
        this.refreshOnScreenChange()
        this.captureInstallPrompt()
    }

    componentDidUpdate (prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname && this.Navigation) {
            this.Navigation.resetNavigation()
        }
    }

    refreshOnScreenChange () {
        /* Refresh the page if the screen size is changed from mobile to desktop or vice versa */
        let resizeTimer
        window.onresize = () => {
            clearTimeout(resizeTimer)
            resizeTimer = setTimeout(() => {
                if (this.state.isMobile !== (window.innerWidth <= this.screenSm)) {
                    location.reload()
                }
            }, 500)
        }
    }

    captureInstallPrompt () {
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault()
            this.setState({ deferredPrompt: e })
            // Eventually we will do something with this
            // For now don't promote it since the logos, loading page etc are gross
        })
    }

    dontShowNavigation () {
    	// Added support for reset-password/[key] URL
    	let pathname = window.location.pathname
    	if (pathname.substr(1).includes('/')) {
            pathname = pathname.substr(0, pathname.indexOf('/', 1))
        }
        return this.dontShowNav.includes(pathname)
    }

    dontShowPaymentsNav () {
        let pathname = window.location.pathname
    	if (pathname.substr(1).includes('/')) {
            pathname = pathname.substr(0, pathname.indexOf('/', 1))
        }
        let paymentsPath = '/standalone-payments'
        return paymentsPath.includes(pathname)
    }

    doShowNotices () {
        return !this.dontShowNavigation() && this.props.location.pathname === '/dashboard'
    }

    render () {
        const errorFallback = ({ error, componentStack, resetError }) => <Error error={error} />

        return (
            <Provider store={store}>
                <div className='container-fluid' style={{ opacity: 0 }} ref={el => this.container = el}>
                    <Sentry.ErrorBoundary fallback={errorFallback}>
                        {this.dontShowNavigation()
                            ? ''
                            : <Navigation
                                    ref={el => this.Navigation = el}
                                    dontShowNav={this.dontShowNavigation()}
                                    dontShowPayments={this.dontShowPaymentsNav()}
                              />}
                        {this.doShowNotices() ? <Notices /> : ''}
                        <div className={this.dontShowNavigation() ? 'login-container' : 'page-container'}>
                        {/* <div className='login-container'> */}
                            <Switch>
                                <PrivateRoute exact path='/' component={Home} />
                                <PrivateRoute exact path='/dashboard' component={MyServices} />
                                <PrivateRoute path='/my-services/mobile/:id(\d+)' component={MobileService} />
                                <PrivateRoute path='/my-services/hwbb/:id(\d+)' component={WirelessService} />
                                <PrivateRoute path='/my-services/mbb/:id(\d+)' component={MobileBroadbandService} />
                                <PrivateRoute path='/my-services/voip/:id(\d+)' component={VoipService} />
                                <PrivateRoute path='/my-services/pstn/:id(\d+)' component={PstnService} />
                                <PrivateRoute path='/my-services/home-secure/:id(\d+)' component={HomeSecureService} />
                                <PrivateRoute path='/my-services/speed-boost/:id(\d+)' component={SpeedBoostService} />
                                <PrivateRoute path='/my-services/:type/:id(\d+)' component={BroadbandService} />
                                <PrivateRoute path='/my-account' component={MyAccount} />
                                <PrivateRoute path='/payment-and-invoices' component={PaymentAndInvoices} />
                                <PrivateRoute path='/messages' component={Messages} />
                                <PrivateRoute path='/sim-only-plan' component={SimOnlyPlan} />
                                <PrivateRoute path='/migrate-mobile' component={MigrateMobile} />
                                {/* <PrivateRoute path="/upgrade-nbn" component={UpgradeToNbn} /> */}
                                {/* <PrivateRoute path='/order-modem' component={OrderModem} /> */}
                                {/* <PrivateRoute path="/pstn-to-voip" component={PstnToVoip} /> */}
                                <PrivateRoute path='/home-phone-voip' component={HomePhoneVoip} />
                                <PrivateRoute path='/unlimited-call-pack' component={UnlimitedCallPack} />
                                <PrivateRoute path='/subscribe-home-secure/:id(\d+)' component={SubscribeToHomeSecure} />
                                <PrivateRoute path='/subscribe-home-secure' component={SubscribeToHomeSecure} />
                                <PrivateRoute path='/faqs' component={Faqs} />
                                <PrivateRoute path='/exetel-a-friend' component={ExetelAFriend} />
                                <PrivateRoute path='/sentry-test-error' component={SentryTestError} />
                                <PrivateRoute path='/mfa' component={Mfa} />
                                <Route path='/login' component={Login} />
                                <Route path='/logout' component={Logout} />
                                <Route path='/forgot-password' component={ForgotPassword} />
                                <Route path='/forgot-username' component={ForgotUsername} />
                                <Route path='/reset-password' component={ResetPassword} />
                                <Route path='/switch-to-nbn' component={SwitchToNbn} />
                                <Route path='/storage-hub' component={CrossStorageHub} />
                                <Route exact path='/standalone-payments/:hash' component={StandalonePayments} />
                                <Route path='/' component={NotFound} />
                            </Switch>
                        </div>
                    </Sentry.ErrorBoundary>
                    {this.dontShowNavigation() ? '' : (this.dontShowPaymentsNav() ? '' : <BottomDetails />)}
                    {this.dontShowNavigation() ? '' : (this.dontShowPaymentsNav() ? '' : <Footer />)}
                </div>
            </Provider>
        )
    }
}

const mapStateToProps = state => ({

})

export default connect(mapStateToProps, { getCustomer })(withRouter(App))



// WEBPACK FOOTER //
// ./resources/js/layout/App.js